<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="info-block">
  <router-link :to="'/hync/ncDetail/'+info.id" class="info-block-a">
    <div class="div-1">
      <div class="div-2">
        <img :src="info.cover_img"/>
      </div>
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-2">{{info.intro.length>labelLength?(info.intro.replace(/<[^>]*>/g,'').substring(0,labelLength)+'...'):info.intro.replace(/<[^>]*>/g,'')}}</div>
      <div class="div-1-3">{{info.create_time}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table">
          <tr>
            <td class="td-title">总期数</td>
            <td class="td-title">当前更新</td>
            <td class="td-title">产品方式</td>
            <td class="td-title">产品价格</td>
            <td rowspan="2" class="td-action"><a class="td-action-1">立即购买</a><a class="td-action-2">了解详情</a></td>
          </tr>
          <tr>
            <td class="td-value">{{info.data_volume}}</td>
            <td class="td-value">{{info.current_count}}期</td>
            <td class="td-value">{{info.price}}电子版</td>
            <td class="td-value price">{{info.price}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <div class="div-3-1">免费咨询</div>
        <div class="div-3-2"><img src="./../../assets/hync_er.png"><div>微信扫码在线咨询</div></div>
        <div class="div-3-3">电话：0871-65137819</div>
        <div class="div-3-4">邮箱：wh@weihengvc.com</div>
      </div>
    </div>


  </router-link>
</div>
</template>

<script>
export default {
  name: 'InfoBlock02',
  props: {
    info: {
      type: Object,
      default: {}
    },
    labelLength:{
      type:Number,
      default:138
    },
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:200px;
  padding:20px;
  margin:0px 1px 20px 1px;
  background-color: #F6F8F9;
  border:1px solid #F6F8F9;
  background-size: 100% 150px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 200px 0px 160px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:40px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#000;
  padding:10px 10px 10px 0px;
}

.div-1-2{
  position:relative;
  height:70px;
  //background:yellow;
  text-align:left;
  color:#888;
  line-height:20px;
  padding:10px 10px 10px 0px;
}

.div-1-3{
  position:relative;
  height:30px;
  //background:blue;
  text-align:left;
  color:#bbb;
  padding:10px 10px 10px 0px;
}

.div-1-4{
  position:relative;
  height:60px;
  //background:green;
  text-align:left;
  color:#bbb;
  padding:10px 0px 10px 0px;
}

.div-1-4-table{
  width:100%;
}
.div-1-4-table .td-title{
  text-align:left;
  color:#888;
}
.div-1-4-table .td-value{
  text-align:left;
  font-size:14px;
  line-height:30px;
  color:#222222;
}

.div-1-4-table .price{
  text-align:left;
  font-size:14px;
  line-height:30px;
  color:var(--color2);
}

.div-1-4-table .price:before{
  content: "\00A5";
  font-size:14px;
  color:var(--color2);
}

.div-1-4-table .td-action{
  text-align:center;
}

.td-action .td-action-1{
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-left:10px;
  background-color: var(--color2);
  color:#fff;

}

.td-action .td-action-2{
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-left:10px;
  background-color: var(--color6);
  color:#fff;
}

.div-2{
  position:absolute;
  left:0px;
  top:0px;
  padding:0px;
  width:141px;
  height:200px;
}

.div-2 img{
  width:141px;
  height:200px;
  border:5px solid #fff;
  box-shadow: #bbb 0px 0px 10px;
}


.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:170px;
  height:170px;
  margin:15px 20px 15px 0px;
  padding-left:10px;
  border-left:1px solid #bbb;
  //background:yellow;
  color:#888;
}

.div-3-1{
  position:relative;
  text-align:center;
  font-weight:600;
  color:#000;
}

.div-3-2{
  margin:0px auto;
  width:110px;
  border:5px solid #fff;
  background:#fff;
  text-align:center;
}

.div-3-2 img{
  width:90px;
}

.div-3-3{
  position:relative;
  text-align:center;
}

.div-3-4{
  position:relative;
  text-align:center;
}

.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock02.vue